import { INBOX_TYPES } from 'shared/mixins/inboxMixin';

export const getInboxSource = (type, phoneNumber, inbox) => {
  switch (type) {
    case INBOX_TYPES.WEB:
      return inbox.website_url || '';

    case INBOX_TYPES.TWILIO:
    case INBOX_TYPES.WHATSAPP:
      return phoneNumber || '';

    case INBOX_TYPES.EMAIL:
      return inbox.email || '';

    default:
      return '';
  }
};
export const getReadableInboxByType = (type, phoneNumber) => {
  switch (type) {
    case INBOX_TYPES.WEB:
      return 'livechat';

    case INBOX_TYPES.FB:
      return 'facebook';

    case INBOX_TYPES.TWITTER:
      return 'twitter';

    case INBOX_TYPES.TWILIO:
      return phoneNumber?.startsWith('whatsapp') ? 'whatsapp' : 'sms';

    case INBOX_TYPES.WHATSAPP:
      return 'whatsapp';

    case INBOX_TYPES.API:
      return 'api';

    case INBOX_TYPES.EMAIL:
      return 'email';

    case INBOX_TYPES.TELEGRAM:
      return 'telegram';

    case INBOX_TYPES.LINE:
      return 'line';

    default:
      return 'chat';
  }
};

export const getInboxClassByType = (type, phoneNumber) => {
  switch (type) {
    case INBOX_TYPES.WEB:
      return 'globe-desktop';

    case INBOX_TYPES.FB:
      return 'brand-facebook';

    // d99d
    case INBOX_TYPES.FB2:
      return 'brand-facebook2';

    case 'Channel::Api_wa_v1':
    case 'Channel::Api_wa_v2':
    case 'Channel::Api_wa_v3':
      return 'brand-whatsapp';

    case 'Channel::Email_gmail':
      return 'brand-gmail';

    case 'Channel::Email_microsoft_api':
      return 'brand-microsoft';
    // .

    case INBOX_TYPES.TWITTER:
      return 'brand-twitter';

    case INBOX_TYPES.TWILIO:
      return phoneNumber?.startsWith('whatsapp')
        ? 'brand-whatsapp'
        : 'brand-sms';

    case INBOX_TYPES.WHATSAPP:
      return 'brand-whatsapp';

    case INBOX_TYPES.API:
      return 'cloud';

    case INBOX_TYPES.EMAIL:
      return 'mail';

    case INBOX_TYPES.TELEGRAM:
      return 'brand-telegram';

    case INBOX_TYPES.TIKTOK:
      return 'brand-tiktok';

    case INBOX_TYPES.LINE:
      return 'brand-line';

    default:
      return 'chat';
  }
};

export const getInboxWarningIconClass = (type, reauthorizationRequired) => {
  if (type === INBOX_TYPES.FB && reauthorizationRequired) {
    return 'warning';
  }
  return '';
};

export const standardContactChannels = [
  {
    key: 'WHATSAPP',
    title: 'WhatsApp',
    input_placeholder: 'WhatsApp number',
    value: '',
    action_link: 'https://wa.me/{{input_value}}',
    enabled: false,
    default_text: '',
    display_text: '',
  },
  {
    key: 'MESSENGER',
    title: 'Messenger',
    input_placeholder: 'Facebook page ID',
    value: '',
    action_link: 'https://m.me/{{input_value}}',
    enabled: false,
    default_text: '',
    display_text: '',
  },
  {
    key: 'EMAIL',
    title: 'Email',
    input_placeholder: 'Email',
    value: '',
    action_link: 'mailto:{{input_value}}',
    enabled: false,
    default_text:
      'You can send us an email to: {{input_value}} or click the following button:',
    display_text:
      'You can send us an email to: {{input_value}} or click the following button:',
  },
  {
    key: 'SMS',
    title: 'SMS',
    input_placeholder: 'Phone number',
    value: '',
    action_link: 'sms://{{input_value}}',
    enabled: false,
    default_text: 'You can send us an SMS to: {{input_value}}',
    display_text: 'You can send us an SMS to: {{input_value}}',
  },
  {
    key: 'PHONECALL',
    title: 'Phone Call',
    input_placeholder: 'Phone number',
    value: '',
    action_link: 'tel://{{input_value}}',
    enabled: false,
    default_text:
      'You can call us to: {{input_value}} or click the following button to call: <button @click="callNumber(phone_number)">Call</button>',
    display_text:
      'You can call us to: {{input_value}} or click the following button to call: <button @click="callNumber(phone_number)">Call</button>',
  },
  {
    key: 'TELEGRAM',
    title: 'Telegram',
    input_placeholder: 'Telegram username',
    value: '',
    action_link: 'https://t.me/{{input_value}}',
    enabled: false,
    default_text: '',
    display_text: '',
  },
  {
    key: 'INSTAGRAM',
    title: 'Instagram',
    input_placeholder: 'Instagram username',
    value: '',
    action_link: 'https://instagram.com/{{input_value}}',
    enabled: false,
    default_text: '',
    display_text: '',
  },
  {
    key: 'TIKTOK',
    title: 'TikTok',
    input_placeholder: 'TikTok username',
    value: '',
    action_link: 'https://tiktok.com/@{{input_value}}',
    enabled: false,
    default_text: '',
    display_text: '',
  },
  {
    key: 'TWITTER',
    title: 'Twitter',
    input_placeholder: 'Twitter (X) username',
    value: '',
    action_link:
      'https://twitter.com/messages/compose?recipient_id={{input_value}}',
    enabled: false,
    default_text: '',
    display_text: '',
  },
  {
    key: 'LINKEDIN',
    title: 'LinkedIn',
    input_placeholder: 'LinkedIn username',
    value: '',
    action_link: 'https://www.linkedin.com/in/{{input_value}}',
    enabled: false,
    default_text: '',
    display_text: '',
  },
];
